import type { TwelveMonthRevenueTrendDTO } from "../models/twelveMonthRevenueTrendDto";
import type { TwelveMonthRevenueTrendEntity } from "../../domain/entities/TwelveMonthRevenueTrendEntity";

export function twelveMonthRevenueTrendDtoToEntity(
  dto: TwelveMonthRevenueTrendDTO
): TwelveMonthRevenueTrendEntity {
  const labels = Array.isArray(dto.labels) ? dto.labels.map(String) : [];
  const monthCountRaw = dto.monthCount;
  const monthCount =
    typeof monthCountRaw === "number" && Number.isFinite(monthCountRaw)
      ? monthCountRaw
      : labels.length;

  return {
    labels,
    values: Array.isArray(dto.values) ? dto.values.map((v) => Number(v) || 0) : [],
    variants: Array.isArray(dto.variants)
      ? (dto.variants.map((v) => (v === "strong" ? "strong" : "normal")) as ("normal" | "strong")[])
      : [],
    averageRevenue: Number(dto.averageRevenue) || 0,
    rangeLabel: typeof dto.rangeLabel === "string" ? dto.rangeLabel : "",
    monthCount,
  };
}
